/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'refresh': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 859.559a338.612 338.612 0 01-282.699-153.427H139.84A415.102 415.102 0 00512 936.942 419.575 419.575 0 00926.655 550.47h77.384L890.423 396.147 776.807 550.47h73.805A343.085 343.085 0 01512 859.559zm0-772.502a418.68 418.68 0 00-409.287 347.559H19.96l113.616 154.768 113.616-154.768H179.65A342.638 342.638 0 01512 166.23a337.718 337.718 0 01256.755 118.984l14.761-3.579h76.937A412.866 412.866 0 00512 87.057z" _fill="#fff"/>'
  }
})
